import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getSeverities = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params
  return api.http.get('/severities', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const getSeveritiesAll = () => {
  return api.http.get(`/severities/select_search`)
}

export const getSeverity = id => {
  return api.http.get(`/severities/${id}`)
}

export const searchSeverities = term => {
  return api.http.get('/severities/select_search', {
    params: {
      term
    }
  })
}

export const getSelectSeverities = (term, callback) => {
  searchSeverities(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteSeverity = id => {
  return api.http.delete(`/severities/${id}`)
}

export const restoreSeverity = id => {
  return api.http.put(`/severities/${id}/restore`)
}

export const editSeverity = severity => {
  return api.http.put(`/severities/${severity._id}`, severity)
}

export const addSeverity = severity => {
  return api.http.post('/severities', severity)
}



// WEBPACK FOOTER //
// ./src/api/severities.js